const map = {
	"./inquire_01.png": 5095,
	"./inquire_02.png": 6092,
	"./inquire_03.png": 8357,
	"./inquire_04.png": 8234,
	"./inquire_05.png": 2339,
	"./inquire_06.png": 5480
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2727;